export const CLASSIC = 'CLASSIC';
export const EXCLUSIVE = 'EXCLUSIVE';
export const SPORTIVE = 'SPORTIVE';

export const designTypes = [CLASSIC, EXCLUSIVE, SPORTIVE];

export default designTypes;
